// AR-5847 permission keys for the Account page.

// Any one opens the Account page where it already exists.
export const ACCOUNT_PAGE_PERMISSION_KEYS = [
  'manage_account',
  'view_account',
  'purchase_shippable',
  'purchase_add_ons',
  'change_subscription_payment_methods',
  'administer_account',
]

// What the AR-5847 backend admits to /facility/crmAccount/; the current one admits every member. Never view_account.
export const CRM_ACCOUNT_PERMISSION_KEYS = [
  'manage_account',
  'administer_account',
  'purchase_shippable',
  'purchase_add_ons',
]

// Orders tab. manage_account joins in the AR-5962 feature release: the current Orders API refuses it. Never view_account.
export const ORDER_VIEW_PERMISSION_KEYS = ['administer_account', 'purchase_shippable', 'purchase_add_ons']

// Keys the Salesforce sync gives a facility's invoicing contact and its contract holder's.
export const SYNC_CONTACT_PERMISSION_KEYS = ['administer_account', 'change_subscription_payment_methods']

// A billing contact the sync created or keyed. AR-5847 legacy: isApContact is the only marker the current backend sends.
export const isSyncContact = membership =>
  membership?.isApContact === true || SYNC_CONTACT_PERMISSION_KEYS.some(key => membership?.permissions?.includes(key))
